import React, { useEffect, useMemo, useState } from "react";
import FiveButtons from "../components/FiveButtons";
import ImageSlider from "../components/ImageSlider";
import { Switch, CircularProgress } from "@mui/material";
import Logo from "../components/Logo";
import { useDispatch, useSelector } from "react-redux";
import {
  addEscaffQoutation,
  adminActions,
  fetchEscaffQoutation,
  fetchPriceList,
  fetchSingleJob,
  signOut,
} from "../store/adminSlice";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2";
import escapeHtml from "../functions/Validator";
import logoo from "../pictures/TheBestescafflogo.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloseIcon from "@mui/icons-material/Close";

function CreateQuotation() {
  const [elevationName, setElevationName] = useState("");
  const [tempArr, setTempArr] = useState([]);
  const [dynamicOBJ, setDynamicOBJ] = useState([]);
  const [result, setResult] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const statePriceList = useSelector((state) => state.admin.priceList);
  const stateSingleJob = useSelector((state) => state.admin.singleJob);
  const escaffQuotationSwalAlert = useSelector(
    (state) => state.admin.swalAlert
  );
  const stateEscaffFetched = useSelector((state) => state.admin.escaffFetched);
  const [additionalItem, setAdditionalItem] = useState([]);
  const [sod, setSod] = useState([]);
  // const [additionalItemInput,setAdditionalItemInput]=useState({additionalItemCost:"",numberOfadditionalItem:""})

  const _id = useSelector((state) => state.admin._id);
  const stateEscaffQoutation = useSelector(
    (state) => state.admin.escaffQoutation
  );
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryParameters = new URLSearchParams(window.location.search);
  const id = queryParameters.get("id");
  const navigate = useNavigate();
  const [data, setData] = useState(stateEscaffQoutation);

  const [sendingData, setSendingData] = useState(data);
  const [preReady, setPreReady] = useState();
  const subscribed = useSelector((state) => state.admin.subscribed);
  const statesignOut = useSelector((state) => state.admin.signOut);

  // Add flag to control when update should happen
  const [shouldSendUpdate, setShouldSendUpdate] = useState(false);

  useEffect(() => {
    if (!_id) {
      navigate("/signin");
    } else if (!subscribed) {
      navigate("/signin");
    }
  }, [_id, subscribed, navigate]);

  useEffect(() => {
    if (statesignOut === "signOut") {
      dispatch(signOut());
    }
  }, [statesignOut, dispatch]);
  const onChangeDate = (e) => {
    const newDate = moment(new Date(e.target.value)).format("YYYY-MM-DD");
    setData({ ...data, dateOfErection: newDate, nextInspectionDate: newDate });
    // setData({ ...data, customerID: stateSingleJob.customer._id })
  };
  const handleElevation = () => {
    if (elevationName !== "") {
      tempArr.push(elevationName);
      setDynamicOBJ([
        ...dynamicOBJ,
        { elevationNamee: "", elevationLength: "0", elevationLifts: "0" },
      ]);
      setElevationName("");
      setData({ ...data, customerID: stateSingleJob.customer._id });
    }
  };
  const handleSubmit = () => {
    if (!result) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        confirmButtonColor: "#60c088",
        text: "Kindly calculate first.!",
      });
    } else {
      console.log(result, "resu");
      setShouldSendUpdate(true); // Set flag to trigger update
      setSendingData({ ...data, jobID: id, totalCostResult: result });
    }
  };

  useEffect(() => {
    // Only send update when flag is true
    if (shouldSendUpdate) {
      try {
        dispatch(addEscaffQoutation({ ...sendingData, adminID: _id }))
          .unwrap()
          .catch((error) => {
            console.error("Error submitting quotation:", error);
            // Show user-friendly error message
            Swal.fire({
              icon: "error",
              title: "Subscription Required",
              text: "Please check your subscription status to continue.",
              confirmButtonColor: "#60c088",
            });
          });
        setShouldSendUpdate(false); // Reset flag after update
      } catch (error) {
        console.error("Error in submit:", error);
        setShouldSendUpdate(false);
      }
    }
  }, [sendingData, shouldSendUpdate, dispatch]);

  useEffect(() => {
    setData(stateEscaffQoutation);
    setAdditionalItem(stateEscaffQoutation.additionalItem);
  }, [stateEscaffQoutation]);

  useEffect(() => {
    if (stateEscaffFetched) {
      // data.dynamicOBJ.map((as) => {
      //     setDynamicOBJ([...dynamicOBJ, { elevationNamee: as.elevationNamee, elevationLength: as.elevationLength, elevationLifts: as.elevationLifts }])
      //     console.log(as.elevationNamee,"-",as.elevationLength,"-",as.elevationLifts);
      // })
      console.log(data.dynamicOBJ);

      setDynamicOBJ(data.dynamicOBJ);
      data.dynamicOBJ.map((a) => {
        tempArr.push(a.elevationNamee);
      });
      dispatch(adminActions.removeEscaffFetched());
      setIsLoading(false);
    }
  }, [data]);

  useEffect(() => {
    console.log(dynamicOBJ);
  }, [dynamicOBJ]);

  useEffect(() => {
    if (escaffQuotationSwalAlert.message === "Saved") {
      Swal.fire({
        icon: "success",
        title: "Saved",
        confirmButtonColor: "#60c088",
      }).then(() => {
        dispatch(adminActions.removeSwalAlert());
        navigate("/pendingprojectqoutes");
      });
    }
    if (escaffQuotationSwalAlert.message === "updatedEscaff") {
      Swal.fire({
        icon: "success",
        title: "Updated",
        confirmButtonColor: "#60c088",
      }).then(() => {
        dispatch(adminActions.removeSwalAlert());
        navigate("/pendingprojectqoutes");
      });
    }
  }, [escaffQuotationSwalAlert]);

  useEffect(() => {
    // Clear any swalAlert first to prevent unwanted updates
    dispatch(adminActions.removeSwalAlert());

    setIsLoading(true);
    try {
      dispatch(fetchEscaffQoutation({ jobID: id, adminID: _id }));
    } catch (err) {
      setError("Failed to load quotation data. Please try again.");
      setIsLoading(false);
    }
  }, []);

  const handleCalculate = () => {
    if (
      dynamicOBJ.length === 0 ||
      dynamicOBJ[0].elevationNamee === "" ||
      data.dateOfErection === ""
    ) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        confirmButtonColor: "#60c088",
        text: "Add Elevation/Select Date & add number of weeks.!",
      });
    } else {
      var WeeklyScaffoldingInspection =
        statePriceList.scaffoldingInspectionPerVisit;
      var elevationResult = dynamicOBJ.reduce(
        (sum, item) =>
          sum +
          item.elevationLength *
            item.elevationLifts *
            statePriceList.linearMerterageCost,
        0
      );

      var gantryResult =
        parseInt(statePriceList.linearMerterageCost) *
        parseInt(data.gantryLength || 0) *
        parseInt(data.gantryLift || 0) *
        parseInt(data.gantryWidth || 0);
      var bayResult =
        parseInt(statePriceList.linearMerterageCost) *
        parseInt(data.baylength || 0) *
        parseInt(data.bayLift || 0) *
        parseInt(data.bayWidth || 0);
      var deckResult =
        parseInt(statePriceList.linearMerterageCost) *
        parseInt(data.deckLength || 0) *
        parseInt(data.deckLift || 0) *
        parseInt(data.deckWidth || 0);
      var hopResult =
        parseInt(statePriceList.hopUpCost) * parseInt(data.hopUp || 0);
      var saddleResult =
        parseInt(statePriceList.saddleCost) * parseInt(data.saddle || 0);
      var throwInResult =
        parseInt(statePriceList.throwinCost) * parseInt(data.throwIn || 0);
      var hakkiLayherResult =
        parseInt(statePriceList.hakkiLayher) * parseInt(data.hakkiStair || 0);
      var fivebyoneResult =
        parseInt(statePriceList.fivebyonepointeightTower) *
        parseInt(data.fiveFootTower || 0) *
        parseInt(data.fiveFootTowerLift || 0);
      console.log(
        fivebyoneResult,
        statePriceList.fivebyonepointeightTower,
        data.fiveFootTower,
        data.fiveFootTowerLift
      );
      var eightByFourResult =
        parseInt(statePriceList.eightbytwopointfourTower) *
        parseInt(data.eightFootTower || 0) *
        parseInt(data.eightFootTowerLift || 0);
      var tenResult =
        parseInt(statePriceList.tenbythreeTower) *
        parseInt(data.tenFootTower || 0) *
        parseInt(data.tenFootTowerLift || 0);
      var thirteenResult =
        parseInt(statePriceList.thirteenbyfourTower) *
        parseInt(data.thirteenFootTower || 0) *
        parseInt(data.thirteenFootTowerLift || 0);
      var additionalItemss = 0;
      if (data.additionalItem && data.additionalItem.length !== 0) {
        additionalItemss = preReady;
        console.log(additionalItemss, "==adddddd====");
      }
      var nonpercentage =
        parseInt(data.streetLicenseCost || 0) +
        parseInt(data.externalDesignCost || 0);
      var res = 0;
      res =
        res +
        elevationResult +
        gantryResult +
        bayResult +
        deckResult +
        hopResult +
        saddleResult +
        throwInResult +
        hakkiLayherResult +
        fivebyoneResult +
        eightByFourResult +
        tenResult +
        thirteenResult +
        additionalItemss;

      var weeks = data.numberOfWeekRequired || 0;
      if (data.WeeklyScaffoldingInspections) {
        console.log(data.WeeklyScaffoldingInspections, "true");
        var nweek = weeks - 1;
        var r1 = nweek * WeeklyScaffoldingInspection;
        res = res + r1;
      }
      console.log(data.customerVatRegisterSwitch, "switchhhhhhh");
      if (data.customerVatRegisterSwitch) {
        var newresult =
          elevationResult +
          gantryResult +
          bayResult +
          deckResult +
          hopResult +
          saddleResult +
          throwInResult +
          hakkiLayherResult +
          fivebyoneResult +
          eightByFourResult +
          tenResult +
          thirteenResult +
          additionalItemss;
        var theVatPercentage =
          ((data.customerVatRegister || 0) / 100) * newresult;
        console.log(theVatPercentage, "thevatpercen");
        res = res + theVatPercentage;
      }
      console.log(
        parseInt(data.numberOfWeekRequired || 0) >
          parseInt(data.standardNumberOfWeek || 0),
        "true ot false"
      );
      console.log(
        parseInt(data.numberOfWeekRequired || 0) +
          " " +
          parseInt(data.standardNumberOfWeek || 0),
        "true ot false"
      );
      if (
        parseInt(data.numberOfWeekRequired || 0) >
        parseInt(data.standardNumberOfWeek || 0)
      ) {
        var percentageWeek =
          (data.numberOfWeekRequired || 0) - (data.standardNumberOfWeek || 0);

        var overhired = statePriceList.overhirePercentage * percentageWeek;

        var orignalPercentage = (overhired / 100) * res;
        console.log(orignalPercentage, "origanl peeeeeeee");
        console.log(res, "ressssssssssss");

        res = res + nonpercentage + orignalPercentage;
      } else {
        res = res + nonpercentage;
      }
      if (!res) {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          confirmButtonColor: "#60c088",
          text: "Check all the inputs.!",
        });
        setResult(res);
      } else {
        setResult(res.toFixed(2));
        setData({ ...data, totalCostResult: res });

        setData({
          ...data,
          dynamicOBJ: dynamicOBJ,
          approved: 0,
          additionalItem: additionalItem,
        });
      }
    }
  };

  const handleDynamic = (e, i) => {
    const { name, value } = e.target;
    const list = [...dynamicOBJ];
    list[i][name] = value;
    setDynamicOBJ(list);
  };

  useEffect(() => {
    setIsLoading(true);
    try {
      if (id) {
        Promise.all([
          dispatch(fetchSingleJob({ _id: id, adminID: _id })),
          dispatch(fetchPriceList({ _id: _id, adminID: _id })),
        ])
          .then(() => {
            setIsLoading(false);
          })
          .catch((err) => {
            setError("Failed to load job data. Please try again.");
            setIsLoading(false);
          });
      } else {
        navigate("/pendingprojectqoutes");
      }
    } catch (err) {
      setError("An unexpected error occurred. Please try again.");
      setIsLoading(false);
    }
  }, []);

  const removeDynamicObject = (a) => {
    setDynamicOBJ(dynamicOBJ.filter((x, i) => i !== a));
    setTempArr(tempArr.filter((b, i) => i !== a));
  };
  const handleAdditionalItem = (e, i) => {
    const { name, value } = e.target;
    const splitr = value.split("_");
    const list = [...additionalItem];
    list[i][name] = splitr[0];
    if (splitr.length > 1) {
      list[i]["additionalItemName"] = splitr[1];
    }
    setAdditionalItem(list);
  };

  useEffect(() => {
    setPreReady(
      additionalItem.reduce(
        (sum, item) =>
          sum +
          parseInt(item.additionalItemCost || 0) *
            parseInt(item.numberOfadditionalItem || 0),
        0
      )
    );
  }, [additionalItem]);

  const addAdditionalItem = () => {
    setAdditionalItem([
      ...additionalItem,
      {
        additionalItemName: "",
        additionalItemCost: 0,
        numberOfadditionalItem: 0,
      },
    ]);
  };
  const handleRemoveAdditionalItem = (i) => {
    const list = [...additionalItem];
    list.splice(i, 1);
    setAdditionalItem(list);
  };

  // Show loading indicator if data is still loading
  if (isLoading) {
    return (
      <div className="w-full h-screen flex flex-col items-center justify-center bg-gray-50">
        <img src={logoo} alt="Escaff Logo" className="h-16 mb-6" />
        <CircularProgress color="success" />
        <p className="mt-4 text-gray-600">Loading quotation data...</p>
      </div>
    );
  }

  // Show error message if there was an error loading data
  if (error) {
    return (
      <div className="w-full h-screen flex flex-col items-center justify-center bg-gray-50">
        <img src={logoo} alt="Escaff Logo" className="h-16 mb-6" />
        <div className="text-red-600 font-medium mb-4">{error}</div>
        <button
          onClick={() => window.location.reload()}
          className="px-4 py-2 bg-lightgreen hover:bg-darkgreen text-white font-medium rounded-md shadow-sm"
        >
          Try Again
        </button>
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col h-full bg-gray-50">
      {/* Header with back and close buttons */}
      <div className="w-full bg-white shadow-md px-4 py-3 flex justify-between items-center sticky top-0 z-40">
        <div className="flex items-center">
          <button
            onClick={() => navigate(-1)}
            className="mr-3 text-gray-700 hover:text-lightgreen transition-colors"
          >
            <ArrowBackIcon />
          </button>
          <img src={logoo} alt="Escaff Logo" className="h-10" />
        </div>
        <button
          onClick={() => navigate("/pendingprojectqoutes")}
          className="text-gray-500 hover:text-lightgreen transition-colors"
        >
          <CloseIcon />
        </button>
      </div>

      <div className="max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-6">
        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <h2 className="text-lg sm:text-xl font-medium text-gray-800 mb-6">
            Create your quotation
          </h2>
          <p className="text-sm text-gray-600 mb-6">
            Create a quotation by filling out the details below
          </p>

          <div className="flex flex-col lg:flex-row gap-6">
            {/* Left Column - Form */}
            <div className="w-full lg:w-1/2">
              <div className="space-y-6">
                {/* Rest of the form components will continue here, but maintaining the same structure */}
                <div className="space-y-3">
                  <label className="block text-sm font-medium text-gray-700">
                    Enter a new elevation and name it
                    <span className="font-normal text-gray-500 ml-1">
                      (example: front elevation or rear elevation)
                    </span>
                  </label>
                  <div className="flex gap-2">
                    <input
                      className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      onChange={(e) =>
                        setElevationName(escapeHtml(e.target.value))
                      }
                      value={elevationName}
                      type="text"
                      required
                    />
                    <button
                      onClick={handleElevation}
                      className="px-4 py-2 bg-lightgreen hover:bg-darkgreen text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors"
                    >
                      Add
                    </button>
                  </div>
                </div>

                {/* Dynamic elevation fields */}
                {dynamicOBJ.map((a, i) => (
                  <div
                    key={i}
                    className="p-4 border border-gray-200 rounded-lg space-y-4"
                  >
                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700">
                        Select elevation
                      </label>
                      <select
                        onChange={(e) => handleDynamic(e, i)}
                        value={dynamicOBJ.elevationNamee}
                        name="elevationNamee"
                        id="elevationName"
                        className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      >
                        <option value="">Select Elevation</option>
                        {tempArr.map((a, idx) =>
                          !stateEscaffQoutation ? (
                            <option key={idx} value={a}>
                              {a}
                            </option>
                          ) : dynamicOBJ[i].elevationNamee === a ? (
                            <option key={idx} value={a} selected>
                              {a}
                            </option>
                          ) : (
                            <option key={idx} value={a}>
                              {a}
                            </option>
                          )
                        )}
                      </select>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Enter elevation length in meters
                        </label>
                        <input
                          onChange={(e) => handleDynamic(e, i)}
                          value={dynamicOBJ[i].elevationLength}
                          name="elevationLength"
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          type="text"
                          required
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Enter the number of lifts
                        </label>
                        <input
                          onChange={(e) => handleDynamic(e, i)}
                          value={dynamicOBJ[i].elevationLifts}
                          name="elevationLifts"
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          type="text"
                          required
                        />
                      </div>
                    </div>
                    <div className="flex justify-end">
                      <button
                        onClick={(e) => removeDynamicObject(i)}
                        className="px-4 py-2 border border-lightgreen text-lightgreen hover:bg-gray-50 font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors"
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                ))}

                <div className="space-y-4 pt-4">
                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Select the date of erection
                    </label>
                    <input
                      className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      value={data.dateOfErection}
                      type="date"
                      onChange={onChangeDate}
                      required
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Enter the number of weeks required
                    </label>
                    <input
                      className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      onChange={(e) =>
                        setData({
                          ...data,
                          numberOfWeekRequired: escapeHtml(e.target.value),
                        })
                      }
                      value={data.numberOfWeekRequired}
                      type="text"
                      required
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Enter the number of standard weeks hire before overhire
                      commence
                    </label>
                    <input
                      className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      onChange={(e) =>
                        setData({
                          ...data,
                          standardNumberOfWeek: escapeHtml(e.target.value),
                        })
                      }
                      value={data.standardNumberOfWeek}
                      type="text"
                      required
                    />
                  </div>
                </div>

                {/* Gantry Section */}
                <div className="mt-8">
                  <h3 className="text-md font-medium text-gray-800 mb-4">
                    Add a Gantry
                  </h3>

                  <div className="space-y-4">
                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700">
                        Select the elevation the Gantry is going to be erected
                        on
                      </label>
                      <select
                        id="elevationName"
                        name="elevationName"
                        onChange={(e) =>
                          setData({
                            ...data,
                            gantryElevation: escapeHtml(e.target.value),
                          })
                        }
                        value={data.gantryElevation}
                        className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      >
                        <option value="">Select Elevation</option>
                        {tempArr.map((a, i) => (
                          <option key={i} value={a}>
                            {a}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Gantry length
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              gantryLength: escapeHtml(e.target.value),
                            })
                          }
                          value={data.gantryLength}
                          type="text"
                          required
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Gantry Width
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              gantryWidth: escapeHtml(e.target.value),
                            })
                          }
                          value={data.gantryWidth}
                          type="text"
                          required
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Number of lifts
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              gantryLift: escapeHtml(e.target.value),
                            })
                          }
                          value={data.gantryLift}
                          type="text"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Loading Bay Section */}
                <div className="mt-8">
                  <h3 className="text-md font-medium text-gray-800 mb-4">
                    Add a Loading Bay
                  </h3>

                  <div className="space-y-4">
                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700">
                        Select if the elevation the Loading Bay is going to be
                        erected on
                      </label>
                      <select
                        id="elevationName"
                        name="elevationName"
                        onChange={(e) =>
                          setData({
                            ...data,
                            bayElevation: escapeHtml(e.target.value),
                          })
                        }
                        className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      >
                        <option value="">Select Elevation</option>
                        {tempArr.map((a, i) => (
                          <option key={i} value={a}>
                            {a}
                          </option>
                        ))}
                      </select>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Bay length
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              baylength: escapeHtml(e.target.value),
                            })
                          }
                          value={data.baylength}
                          type="text"
                          required
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Bay width
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              bayWidth: escapeHtml(e.target.value),
                            })
                          }
                          value={data.bayWidth}
                          type="text"
                          required
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Number of lifts
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              bayLift: escapeHtml(e.target.value),
                            })
                          }
                          value={data.bayLift}
                          type="text"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Bird Cage/Crash Deck */}
                <div className="mt-8">
                  <h3 className="text-md font-medium text-gray-800 mb-4">
                    Bird Cage/Crash Deck
                  </h3>

                  <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700">
                        Length
                      </label>
                      <input
                        className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                        onChange={(e) =>
                          setData({
                            ...data,
                            deckLength: escapeHtml(e.target.value),
                          })
                        }
                        value={data.deckLength}
                        type="text"
                        required
                      />
                    </div>
                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700">
                        Width
                      </label>
                      <input
                        className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                        onChange={(e) =>
                          setData({
                            ...data,
                            deckWidth: escapeHtml(e.target.value),
                          })
                        }
                        value={data.deckWidth}
                        type="text"
                        required
                      />
                    </div>
                    <div className="space-y-2">
                      <label className="block text-sm font-medium text-gray-700">
                        Number of lifts
                      </label>
                      <input
                        className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                        onChange={(e) =>
                          setData({
                            ...data,
                            deckLift: escapeHtml(e.target.value),
                          })
                        }
                        value={data.deckLift}
                        type="text"
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* Additional Components */}
                <div className="mt-8 space-y-4">
                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Enter the number of Hop-Ups
                    </label>
                    <input
                      className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      type="text"
                      onChange={(e) =>
                        setData({ ...data, hopUp: escapeHtml(e.target.value) })
                      }
                      value={data.hopUp}
                      required
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Enter the number of Saddles
                    </label>
                    <input
                      className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      onChange={(e) =>
                        setData({ ...data, saddle: escapeHtml(e.target.value) })
                      }
                      value={data.saddle}
                      type="text"
                      required
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Enter the number of Throw-Ins
                    </label>
                    <input
                      className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      onChange={(e) =>
                        setData({
                          ...data,
                          throwIn: escapeHtml(e.target.value),
                        })
                      }
                      value={data.throwIn}
                      type="text"
                      required
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Hakki/Lahyer Stair number of lifts
                    </label>
                    <input
                      className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      type="text"
                      onChange={(e) =>
                        setData({
                          ...data,
                          hakkiStair: escapeHtml(e.target.value),
                        })
                      }
                      value={data.hakkiStair}
                      required
                    />
                  </div>
                </div>

                {/* Towers Section */}
                <div className="mt-8">
                  <h3 className="text-md font-medium text-gray-800 mb-4">
                    Towers - enter the number of towers required of each size
                  </h3>

                  <div className="space-y-6">
                    <div className="grid grid-cols-1 sm:grid-cols-3 sm:col-span-2 gap-4">
                      <div className="sm:col-span-2 space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          5 foot/1.8 meter tower
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          type="text"
                          onChange={(e) =>
                            setData({
                              ...data,
                              fiveFootTower: escapeHtml(e.target.value),
                            })
                          }
                          value={data.fiveFootTower}
                          required
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Number of lifts
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              fiveFootTowerLift: escapeHtml(e.target.value),
                            })
                          }
                          value={data.fiveFootTowerLift}
                          type="text"
                          required
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 sm:col-span-2 gap-4">
                      <div className="sm:col-span-2 space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          8 foot/2.4 meter tower
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              eightFootTower: escapeHtml(e.target.value),
                            })
                          }
                          value={data.eightFootTower}
                          type="text"
                          required
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Number of lifts
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              eightFootTowerLift: escapeHtml(e.target.value),
                            })
                          }
                          value={data.eightFootTowerLift}
                          type="text"
                          required
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 sm:col-span-2 gap-4">
                      <div className="sm:col-span-2 space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          10 foot/3.0 meter tower
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              tenFootTower: escapeHtml(e.target.value),
                            })
                          }
                          value={data.tenFootTower}
                          type="text"
                          required
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Number of lifts
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              tenFootTowerLift: escapeHtml(e.target.value),
                            })
                          }
                          value={data.tenFootTowerLift}
                          type="text"
                          required
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 sm:col-span-2 gap-4">
                      <div className="sm:col-span-2 space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          13 foot/4.0 meter tower
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              thirteenFootTower: escapeHtml(e.target.value),
                            })
                          }
                          value={data.thirteenFootTower}
                          type="text"
                          required
                        />
                      </div>
                      <div className="space-y-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Number of lifts
                        </label>
                        <input
                          className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                          onChange={(e) =>
                            setData({
                              ...data,
                              thirteenFootTowerLift: escapeHtml(e.target.value),
                            })
                          }
                          value={data.thirteenFootTowerLift}
                          type="text"
                          required
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Options Section */}
                <div className="mt-8 space-y-6">
                  <div className="flex items-center space-x-4">
                    <label className="text-sm font-medium text-gray-700">
                      Weekly Scaffolding Inspections
                    </label>
                    <Switch
                      onChange={() =>
                        setData({
                          ...data,
                          WeeklyScaffoldingInspections:
                            !data.WeeklyScaffoldingInspections,
                        })
                      }
                      checked={data.WeeklyScaffoldingInspections}
                      color="success"
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Enter the Street license Cost
                    </label>
                    <input
                      className="bg-gray-100 border border-gray-200 rounded p-2 w-full md:w-1/2 focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      onChange={(e) =>
                        setData({
                          ...data,
                          streetLicenseCost: escapeHtml(e.target.value),
                        })
                      }
                      value={data.streetLicenseCost}
                      type="text"
                      required
                    />
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Customer is VAT Registered
                    </label>
                    <div className="flex items-center">
                      <input
                        className="bg-gray-100 border border-gray-200 rounded p-2 w-full md:w-1/2 focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                        onChange={(e) =>
                          setData({
                            ...data,
                            customerVatRegister: escapeHtml(e.target.value),
                          })
                        }
                        value={data.customerVatRegister}
                        type="text"
                        required
                      />
                      <Switch
                        className="ml-4"
                        onChange={() =>
                          setData({
                            ...data,
                            customerVatRegisterSwitch:
                              !data.customerVatRegisterSwitch,
                          })
                        }
                        checked={data.customerVatRegisterSwitch}
                        color="success"
                      />
                    </div>
                  </div>

                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      External Design Cost
                    </label>
                    <input
                      className="bg-gray-100 border border-gray-200 rounded p-2 w-full md:w-1/2 focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                      onChange={(e) =>
                        setData({
                          ...data,
                          externalDesignCost: escapeHtml(e.target.value),
                        })
                      }
                      value={data.externalDesignCost}
                      type="text"
                      required
                    />
                  </div>
                </div>

                {/* Additional Items Section */}
                <div className="mt-8">
                  <h3 className="text-md font-medium text-gray-800 mb-4">
                    Additional items
                  </h3>

                  <div className="space-y-4">
                    {additionalItem.map((x, i) => (
                      <div
                        key={i}
                        className="p-4 border border-gray-200 rounded-lg space-y-4"
                      >
                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                          <div className="sm:col-span-2 space-y-2">
                            <label className="block text-sm font-medium text-gray-700">
                              Select an item from your list
                            </label>
                            <select
                              onChange={(e) => handleAdditionalItem(e, i)}
                              value={
                                x.additionalItemCost +
                                "_" +
                                x.additionalItemName
                              }
                              name="additionalItemCost"
                              id="elevationName"
                              className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                            >
                              <option value=""></option>
                              {statePriceList.addItem.map((a, idx) => (
                                <option key={idx} value={a.cost + "_" + a.name}>
                                  {a.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <div className="space-y-2">
                            <label className="block text-sm font-medium text-gray-700">
                              Number of items
                            </label>
                            <input
                              className="bg-gray-100 border border-gray-200 rounded p-2 w-full focus:outline-none focus:ring-2 focus:ring-lightgreen transition"
                              value={x.numberOfadditionalItem}
                              name="numberOfadditionalItem"
                              onChange={(e) => handleAdditionalItem(e, i)}
                              type="text"
                              required
                            />
                          </div>
                        </div>
                        <div className="flex justify-end">
                          <button
                            onClick={() => handleRemoveAdditionalItem(i)}
                            className="px-4 py-2 border border-lightgreen text-lightgreen hover:bg-gray-50 font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors"
                          >
                            Remove
                          </button>
                        </div>
                      </div>
                    ))}

                    <button
                      onClick={addAdditionalItem}
                      className="px-4 py-2 bg-lightgreen hover:bg-darkgreen text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors"
                    >
                      Add Item
                    </button>
                  </div>
                </div>

                {/* Total Cost Section */}
                <div className="mt-8 p-4 bg-gray-50 border border-gray-200 rounded-lg">
                  <div className="space-y-2">
                    <label className="block text-sm font-medium text-gray-700">
                      Total cost
                    </label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <span className="text-gray-700">£</span>
                      </div>
                      <input
                        className="bg-gray-100 border border-gray-200 rounded p-2 w-full pl-8 focus:outline-none focus:ring-2 focus:ring-lightgreen transition font-medium text-gray-800"
                        step=".01"
                        disabled
                        value={result}
                        type="text"
                        required
                      />
                    </div>
                  </div>
                </div>

                {/* Add controls at the bottom */}
                <div className="pt-6 flex justify-between">
                  <button
                    onClick={(e) => handleCalculate()}
                    className="px-6 py-2 bg-lightgreen hover:bg-darkgreen text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors"
                  >
                    Calculate
                  </button>
                  <button
                    type="button"
                    onClick={handleSubmit}
                    className="px-6 py-2 bg-lightgreen hover:bg-darkgreen text-white font-medium rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lightgreen transition-colors"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>

            {/* Right Column - Image Slider */}
            <div className="w-full lg:w-1/2">
              {stateSingleJob.Images && (
                <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
                  <ImageSlider
                    images={stateSingleJob.Images}
                    stateSingleJob={stateSingleJob}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateQuotation;
